import { useTranslation } from "react-i18next";
import type { Lang } from "../../../shared/i18n/lang";
import { Seo } from "../../../shared/seo/Seo";
import { LandingJsonLd } from "../../../shared/seo/JsonLd";
import Header from "../../../widgets/header/Header";
import Hero from "../../../widgets/hero/Hero";
import BentoFeatures from "../../../widgets/features/BentoFeatures";
import HowItWorks from "../../../widgets/howitworks/HowItWorks";
import Pricing from "../../../widgets/pricing/Pricing";
import Faq from "../../../widgets/faq/Faq";
import DownloadCta from "../../../widgets/cta/DownloadCta";
import Footer from "../../../widgets/footer/Footer";

const MainLayout = () => {
  const { i18n } = useTranslation();
  const lang: Lang = i18n.language === "ru" ? "ru" : "uz";

  // `.lp` gives the v4 landing the prototype's `line-height: normal` (Tailwind preflight sets 1.5).
  return (
    <div className="lp">
      <Seo path="/" lang={lang} />
      <LandingJsonLd lang={lang} />
      <Header />
      <main id="main">
        <Hero />
        <BentoFeatures />
        <HowItWorks />
        <Pricing />
        <Faq />
        <DownloadCta />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
